import { render, staticRenderFns } from "./url.vue?vue&type=template&id=724126fa&scoped=true"
import script from "./url.vue?vue&type=script&lang=js"
export * from "./url.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724126fa",
  null
  
)

export default component.exports